/**
 * Color palette presented to authors in the HTML rich-text editor (text +
 * highlight pickers). These are user-content choices, not theme tokens —
 * they live under `data/` alongside other content-data sets so the design
 * token linter skips them. Excluded via the `data/htmlEditorColors` pattern
 * in [scripts/check-design-tokens.mjs](../../scripts/check-design-tokens.mjs).
 */

/** Curated swatches shown in the color/highlight popovers. */
export const HTML_EDITOR_PRESET_COLORS: ReadonlyArray<string> = [
  '#000000', '#4a4a4a', '#9b9b9b', '#ffffff',
  '#d0021b', '#f5a623', '#f8e71c', '#7ed321',
  '#417505', '#50e3c2', '#4a90e2', '#9013fe',
  '#bd10e0', '#b8e986', '#8b572a', '#ff69b4',
];

/** Seed value for the hex-input field when no color is currently applied. */
export const HTML_EDITOR_DEFAULT_COLOR = '#000000';
